import React from "react";
import { Star } from "lucide-react";

export default function StarRating({ rating = 0, size = 14, showValue = false, className = "" }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <span className={`inline-flex items-center gap-1 ${className}`} data-testid="star-rating">
      <span className="inline-flex items-center">
        {stars.map((s) => {
          const filled = rating >= s - 0.25;
          const half = !filled && rating >= s - 0.75;
          return (
            <Star
              key={s}
              size={size}
              strokeWidth={1.5}
              className={
                filled
                  ? "fill-[#C05A46] text-[#C05A46]"
                  : half
                  ? "fill-[#C05A46]/40 text-[#C05A46]"
                  : "text-[#C05A46]/40"
              }
            />
          );
        })}
      </span>
      {showValue && (
        <span className="text-xs text-[#786B63] tabular-nums">
          {rating > 0 ? rating.toFixed(1) : "—"}
        </span>
      )}
    </span>
  );
}
